<template>
  <div class="wrap">
    <grid-wmx :item="object" type="yb"></grid-wmx>
    <van-form class="content">
      <van-field
        v-if="dqzt == '01'"
        :required="true"
        readonly
        clickable
        :value="clfsName"
        label="处理方式"
        input-align="right"
        placeholder="请选择"
        @click="clfsShow = true"
        right-icon="arrow-down"
      />

      <xzry v-show="xybclrShow" :queryData="queryData" @selectChange="selectXybclr"></xzry>

      <van-cell title="处理内容" value="" :border="false" />
      <textarea placeholder="请输入处理内容" class="xxnr" v-model="model.clnr"></textarea>
    </van-form>
    <div class="b-btn">
      <button class="b-button" @click="clickSumbit">提交</button>
    </div>
    <van-action-sheet
      v-model="clfsShow"
      :actions="clfsList"
      @select="selectClfs"
      close-on-click-action
      cancel-text="取消"
    />
  </div>
</template>

<script>
import gridWmx from '@/views/common//grid-wmx'
import xzry from '@/views/common/xzry'
import { getAction, postAction } from '@/api/manage'
export default {
  components: {
    gridWmx,
    xzry,
  },
  data() {
    return {
      object: {},
      model: {
        clfs: '',
        czry: '', //username,
        clnr: '',
        id: '',
      },
      clfsShow: false,
      czryName: '',
      xybclrShow: false,
      dqzt: '',
      clfsName: '',
      clfsList: [
        { name: '交办', value: '02' },
        { name: '无效数据', value: '03' },
      ],
      queryData: {},
    }
  },
  created() {
    let e = this.$route.query
    this.model.id = e.id
    this.dqzt = e.dqzt
    if (this.dqzt == '02') {
      this.model.clfs = '04'
    }
    this.getData()
  },
  methods: {
    getData() {
      let params = {
        pageNo: '1',
        id: this.model.id,
      }
      getAction('/zhshj/sbdwmx/page/db/app', params).then((res) => {
        if (res.success) {
          let obj = res.result
          this.object = obj.records[0]
        }
      })
    },
    selectClfs(obj) {
      this.clfsName = obj.name
      this.model.clfs = obj.value
      this.queryData = { cxfs: 'eq', roleCode: 'bddy', orgCode: this.object.sysOrgCode };
      if (this.model.clfs == '02') {
        this.xybclrShow = true
      } else {
        this.xybclrShow = false
      }
    },
    selectXybclr(data) {
      this.model.czry = data.username
      this.czryName = data.realname
    },
    clickSumbit() {
      if (this.model.clfs == '') {
        return this.$u.toast('请选择处理方式')
      }

      if (this.model.clfs == '02' && this.model.czry == '') {
        return this.$u.toast('请选择下一步处理人')
      }

      if (this.model.clnr == '') {
        return this.$u.toast('请输入处理内容')
      }

      this.uploadData()
    },
    uploadData() {
      postAction('/zhshj/sbdwmx/docl', this.model).then((res) => {
        if (res.success) {
          this.$toast('提交成功')
          this.$router.go(-1)
        } else {
          this.$toast(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: #f5f5f5;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}

.b-btn {
  padding: 0 20px;
  margin: 20px 0;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.content {
  background: #fff;
}
</style>
